import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "../../../../components/datagrid";
import { useCompletedCountryColumns } from "./hooks/useCompletedCountryColumns";
import { useNavigate } from "react-router-dom";
import { useCompletedCountryOverview } from "../../dataHooks/countryQueries";
import { useRoles } from "../../../../auth/useRoles";
import {
  hasAnyAppRole,
  isGlobalLifecycleRole
} from "../../../../auth/permissions";

type Props = {};

export const CompletedCountriesGrid: FC<Props> = () => {
  const { data, isLoading, isFetching } = useCompletedCountryOverview();

  const rows = data || [];
  const navigate = useNavigate();
  const roles = useRoles();
  const columns = useCompletedCountryColumns(
    rows,
    isGlobalLifecycleRole(roles)
  );
  const showGrantModeEmptyState =
    !isLoading && !isFetching && rows.length === 0 && !hasAnyAppRole(roles);

  if (showGrantModeEmptyState) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        }}
      >
        <Typography variant="h6">
          You do not have access to any completed country additions yet.
        </Typography>
      </Box>
    );
  }

  return (
    <DataGrid
      loading={isLoading || isFetching}
      columns={columns}
      rows={rows}
      getRowId={(row) => row.id}
      onRowClick={(r) => navigate(`/countries/country/${r.id}`)}
      searchPlaceholder="Search completed country additions"
      exportFileName="Completed country additions"
      initialState={{
        sorting: {
          sortModel: [
            {
              field: "signOffCompletedAt",
              sort: "desc"
            }
          ]
        }
      }}
      sx={{
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
          outline: "none"
        }
      }}
    />
  );
};
